import React from 'react'
import Breadcrumb from './Breadcrumb';
import Supplierlisting from './SupplierListing';




function SupplierPage() {
    return ( 
        <>
        <Breadcrumb />
        <Supplierlisting />
        {/* <Herobottom />        */}
      
        </>
     );
}

export default SupplierPage;